<template>
  <div class="wrapper" @click="selectOutsideEvent">
    <div class="wrap">
      <div class="wrapBg"></div>
      <leftLayout></leftLayout>
      <headerLayout></headerLayout>
      <main>
        <div class="container">
          <section class="section01">
            <div class="object01">
              골프클럽 등록
            </div>
          </section>
          <!-- 휴장일 설정 활성화(Class) : offDayActive -->
          <section class="section02">
            <div class="object01"></div>
            <div class="object02"></div>
            <div class="object03">
              상태
            </div>
            <div class="object04">
              <ul>
                <li class="active">
                  <label>
                    <input type="radio" v-model="clubInfo.active_status" value="active"/>
                    <i></i>
                    <span>활성화</span>
                  </label>
                </li>
                <li class="inactive">
                  <label>
                    <input type="radio" v-model="clubInfo.active_status"  value="inactive"/>
                    <i></i>
                    <span>비활성화</span>
                  </label>
                </li>
              </ul>
            </div>
            <div class="object05"></div>
            <div class="object06"></div>
            <div class="object07">
              골프클럽명
            </div>
            <div class="object08">
              <input type="text" v-model="clubInfo.club_name" />
            </div>
            <div class="object09"></div>
            <div class="object10">
              주소
            </div>
            <div class="object1101">
              <input type="text" v-model="clubInfo.club_address"/>
            </div>
            <div class="object1102">
              <!--<input type="text" />-->
            </div>
            <div class="object12"></div>
            <div class="object13">
              연락처
            </div>
            <div class="object14">
              <input type="text" v-model="clubInfo.club_telno"/>
            </div>
            <div class="object15"></div>
            <div class="object16">
              대표자명
            </div>
            <div class="object17">
              <input type="text" v-model="clubInfo.club_represent_name"/>
            </div>
            <div class="object18"></div>
            <div class="object19"></div>
            <div class="object20">
              운영 상태
            </div>
            <div class="object21">
              <div class="formSelect" ref="select01">
                <div class="formSelectList" @click="openSelect01">
                  <input type="text" v-model="manageStatusName" placeholder="운영상태" readonly />
                </div>
                <div class="formSelectPopup select01">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="운영 상태를 선택하세요." />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="manageStatusInfo in manageStatusList" :key="manageStatusInfo.name">
                                <label>
                                  <input type="radio" v-model="selectManageStatus" :value="manageStatusInfo.code" v-on:change="confirmManageStatus"/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{manageStatusInfo.name}}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object22"></div>
            <div class="object23"></div>
            <div class="object24">
              APL 지원 상태
            </div>
            <div class="object25">
              <div class="formSelect" ref="select02">
                <div class="formSelectList" @click="openSelect02">
                  <input type="text" v-model="aplStatusName" placeholder="APL상태" readonly />
                </div>
                <div class="formSelectPopup select02">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="APL 지원 상태를 선택하세요." />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li v-for="aplStatusInfo in aplStatusList" :key="aplStatusInfo.name">
                                <label>
                                  <input type="radio" v-model="selectAplStatus" :value="aplStatusInfo.code" v-on:change="confirmAplStatus"/>
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>{{aplStatusInfo.name}}</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object26"></div>
            <div class="object27"></div>
            <div class="object28">
              지역
            </div>
            <div class="object29">
              <div class="formSelect">
                <div class="formSelectList">
                  <input type="text" placeholder="지역을 선택하세요." readonly />
                </div>
                <div class="formSelectPopup select03">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="지역을 선택하세요." />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>경기도</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>인천</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>강원</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>충북</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>충남</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>경북</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>경남</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>전라도</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>제주도</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object30"></div>
            <div class="object31">
              핀 사이즈(mm)
            </div>
            <div class="object32">
              <div class="formSelect">
                <div class="formSelectList">
                  <input type="text" placeholder="핀 사이즈를 선택하세요." readonly />
                </div>
                <div class="formSelectPopup select04">
                  <div class="formSelectPopup-container">
                    <div class="outer">
                      <div class="inner">
                        <div class="formSelectPopup-box">
                          <div class="formSelectPopup-zone">
                            <div class="formSelectPopup-header">
                              <input type="text" placeholder="핀 사이즈를 선택하세요." />
                            </div>
                            <ul class="formSelectPopup-body">
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>13</span>
                                </label>
                              </li>
                              <li>
                                <label>
                                  <input type="radio" />
                                  <input type="checkbox" />
                                  <i></i>
                                  <span>27</span>
                                </label>
                              </li>
                            </ul>
                            <div class="formSelectPopup-footer">
                              <button class="formSelectPopup-cancel">
                                취소
                              </button>
                              <!-- 비활성(Attribute) : disabled -->
                              <button class="formSelectPopup-confirm">
                                확인
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object33"></div>
            <div class="object34">
              휴장일 설정
            </div>
            <div class="object35">
              <div class="component-switch">
                <div class="co-body">
                  <label>
                    <input type="checkbox" />
                    <i></i>
                  </label>
                </div>
              </div>
            </div>
            <div class="object36"></div>
            <div class="offDaySetting">
              <div class="object37">
                기간
              </div>
              <div class="object38">
                <div class="formCalendar">
                  <div class="formCalendarList">
                    <input type="text" value="2020/05/17 ~ 2020/06/17" readonly />
                  </div>
                  <div class="formCalendarPopup typeTerm">
                    <div class="formCalendarPopup-container">
                      <div class="formCalendarPopup-box">
                        <div class="formCalendarPopup-zone">
                          <div class="formCalendarPopup-wrap">
                            <div class="formCalendarPopup01">
                              <div class="formCalendarPopup-header">
                                <div class="prev">
                                  이전
                                </div>
                                <div class="title">
                                  2020년 3월
                                </div>
                                <div class="next">
                                  다음
                                </div>
                              </div>
                              <div class="formCalendarPopup-body">
                                <ul class="day">
                                  <!-- 선택(Class) : active / 선택시작(Class) : startActive / 선택끝(Class) : endActive -->
                                  <!-- 일요일,공휴일 일때(Class) : holiday / 이전 or 다음달 날짜 일때(Class) : none -->
                                  <li class="holiday">
                                    일
                                  </li>
                                  <li>
                                    월
                                  </li>
                                  <li>
                                    화
                                  </li>
                                  <li>
                                    수
                                  </li>
                                  <li>
                                    목
                                  </li>
                                  <li>
                                    금
                                  </li>
                                  <li>
                                    토
                                  </li>
                                </ul>
                                <ul class="num">
                                  <li class="holiday">
                                    1
                                  </li>
                                  <li class="active">
                                    2
                                  </li>
                                  <li>
                                    3
                                  </li>
                                  <li>
                                    4
                                  </li>
                                  <li>
                                    5
                                  </li>
                                  <li>
                                    6
                                  </li>
                                  <li>
                                    7
                                  </li>
                                  <li class="holiday">
                                    8
                                  </li>
                                  <li>
                                    9
                                  </li>
                                  <li>
                                    10
                                  </li>
                                  <li>
                                    11
                                  </li>
                                  <li>
                                    12
                                  </li>
                                  <li>
                                    13
                                  </li>
                                  <li>
                                    14
                                  </li>
                                  <li class="holiday">
                                    15
                                  </li>
                                  <li>
                                    16
                                  </li>
                                  <li>
                                    17
                                  </li>
                                  <li>
                                    18
                                  </li>
                                  <li>
                                    19
                                  </li>
                                  <li>
                                    20
                                  </li>
                                  <li>
                                    21
                                  </li>
                                  <li class="holiday">
                                    22
                                  </li>
                                  <li>
                                    23
                                  </li>
                                  <li>
                                    24
                                  </li>
                                  <li>
                                    25
                                  </li>
                                  <li>
                                    26
                                  </li>
                                  <li>
                                    27
                                  </li>
                                  <li>
                                    28
                                  </li>
                                  <li class="holiday">
                                    29
                                  </li>
                                  <li>
                                    30
                                  </li>
                                  <li>
                                    31
                                  </li>
                                  <li class="none">
                                    1
                                  </li>
                                  <li class="none">
                                    2
                                  </li>
                                  <li class="none">
                                    3
                                  </li>
                                  <li class="none">
                                    4
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div class="formCalendarPopup02">
                              <div class="formCalendarPopup-header">
                                <div class="prev">
                                  이전
                                </div>
                                <div class="title">
                                  2020년 4월
                                </div>
                                <div class="next">
                                  다음
                                </div>
                              </div>
                              <div class="formCalendarPopup-body">
                                <ul class="day">
                                  <!-- 선택(Class) : active / 선택시작(Class) : startActive / 선택끝(Class) : endActive -->
                                  <!-- 일요일,공휴일 일때(Class) : holiday / 이전 or 다음달 날짜 일때(Class) : none -->
                                  <li class="holiday">
                                    일
                                  </li>
                                  <li>
                                    월
                                  </li>
                                  <li>
                                    화
                                  </li>
                                  <li>
                                    수
                                  </li>
                                  <li>
                                    목
                                  </li>
                                  <li>
                                    금
                                  </li>
                                  <li>
                                    토
                                  </li>
                                </ul>
                                <ul class="num">
                                  <li class="none">
                                    29
                                  </li>
                                  <li class="none">
                                    30
                                  </li>
                                  <li class="none">
                                    31
                                  </li>
                                  <li>
                                    1
                                  </li>
                                  <li>
                                    2
                                  </li>
                                  <li>
                                    3
                                  </li>
                                  <li>
                                    4
                                  </li>
                                  <li class="holiday">
                                    5
                                  </li>
                                  <li class="startActive">
                                    6
                                  </li>
                                  <li class="active">
                                    7
                                  </li>
                                  <li class="active">
                                    8
                                  </li>
                                  <li class="active">
                                    9
                                  </li>
                                  <li class="active">
                                    10
                                  </li>
                                  <li class="active">
                                    11
                                  </li>
                                  <li class="holiday active">
                                    12
                                  </li>
                                  <li class="endActive">
                                    13
                                  </li>
                                  <li>
                                    14
                                  </li>
                                  <li>
                                    15
                                  </li>
                                  <li>
                                    16
                                  </li>
                                  <li>
                                    17
                                  </li>
                                  <li>
                                    18
                                  </li>
                                  <li class="holiday">
                                    19
                                  </li>
                                  <li>
                                    20
                                  </li>
                                  <li>
                                    21
                                  </li>
                                  <li>
                                    22
                                  </li>
                                  <li>
                                    23
                                  </li>
                                  <li>
                                    24
                                  </li>
                                  <li>
                                    25
                                  </li>
                                  <li class="holiday">
                                    26
                                  </li>
                                  <li>
                                    27
                                  </li>
                                  <li>
                                    28
                                  </li>
                                  <li>
                                    29
                                  </li>
                                  <li>
                                    30
                                  </li>
                                  <li class="none">
                                    1
                                  </li>
                                  <li class="none">
                                    2
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="formCalendarPopup-footer">
                            <button class="formCalendarPopup-cancel">
                              취소
                            </button>
                            <!-- 비활성(Attribute) : disabled -->
                            <button class="formCalendarPopup-confirm">
                              확인
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="object39"></div>
              <div class="object40">
                주차/요일
              </div>
              <div class="object41">
                <div class="checkbox">
                  <ul>
                    <li>
                      <label>
                        <input type="checkbox" />
                        <i></i>
                        <span>1주차</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="checkbox" />
                        <i></i>
                        <span>2주차</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="checkbox" />
                        <i></i>
                        <span>3주차</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="checkbox" />
                        <i></i>
                        <span>4주차</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="checkbox" />
                        <i></i>
                        <span>5주차</span>
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="formSelect">
                  <div class="formSelectList">
                    <input type="text" placeholder="요일" readonly />
                  </div>
                  <div class="formSelectPopup select04">
                    <div class="formSelectPopup-container">
                      <div class="outer">
                        <div class="inner">
                          <div class="formSelectPopup-box">
                            <div class="formSelectPopup-zone">
                              <div class="formSelectPopup-header">
                                <input type="text" placeholder="핀 사이즈를 선택하세요." />
                              </div>
                              <ul class="formSelectPopup-body">
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>월요일</span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>화요일</span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>수요일</span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>목요일</span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>금요일</span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>토요일</span>
                                  </label>
                                </li>
                                <li>
                                  <label>
                                    <input type="radio" />
                                    <input type="checkbox" />
                                    <i></i>
                                    <span>일요일</span>
                                  </label>
                                </li>
                              </ul>
                              <div class="formSelectPopup-footer">
                                <button class="formSelectPopup-cancel">
                                  취소
                                </button>
                                <!-- 비활성(Attribute) : disabled -->
                                <button class="formSelectPopup-confirm">
                                  확인
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="object42"></div>
            <div class="object43">
              핀 교체 방식
            </div>
            <div class="object44">
              <input type="text" />
            </div>
            <div class="object45"></div>
            <div class="object46">
              특이사항
            </div>
            <div class="object47">
              <input type="text" />
            </div>
            <div class="object48"></div>
            <div class="object49">
              골프클럽 로고
            </div>
            <!-- 툴팁 활성(Class) : tooltipActive -->
            <div class="object50" :class="tooltipActive ? 'tooltipActive' : ''" ref="tooltip" @click="openTooltip">
              <div class="tooltip">
                76x26 사이즈로 등록하세요. 100KB 이하의 이미지 파일(jpg,gif,png)만 등록 가능합니다.
              </div>
            </div>
            <!-- 첨부파일 있을때(Class) : imageActive -->
            <div class="object51" :class="clubInfo.club_logo !== '' ? 'imageActive' : ''">
              <div class="attachment">
                <div class="bg">
                  이미지를 첨부해주세요.
                </div>
                <div class="image">
                  <div class="item" :style="{'background-image': 'url(' + clubInfo.club_logo + ')'}"></div>
                </div>
                <input @change="handleImage" type="file" accept="image/*" />
              </div>
            </div>
          </section>
          <section class="section03">
            <div class="object01">
              <button class="cancel">
                취소
              </button>
            </div>
            <div class="object02">
              <!-- 비활성(Attribute) : disabled -->
              <button class="registration">
                등록
              </button>
            </div>
          </section>
        </div>
      </main>
      <footerLayout></footerLayout>
      <div class="formSelectPopup select01">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select01">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="운영 상태를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li v-for="manageStatusInfo in manageStatusList" :key="manageStatusInfo.name">
                      <label>
                        <input type="radio" v-model="selectManageStatus" :value="manageStatusInfo.code" v-on:change="confirmManageStatus"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>{{manageStatusInfo.name}}</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select02">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone" ref="m_select02">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="APL 지원 상태를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li>
                      <label>
                        <input type="radio" v-model="clubInfo.manage_status" value="active" />
                        <input type="checkbox" />
                        <i></i>
                        <span>운영중</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" v-model="clubInfo.manage_status" value="inactive"/>
                        <input type="checkbox" />
                        <i></i>
                        <span>운영예정</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select03">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="지역을 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>경기도</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>인천</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>강원</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>충북</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>충남</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>경북</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>경남</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>전라도</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>제주도</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="formSelectPopup select04">
        <div class="formSelectPopup-container">
          <div class="outer">
            <div class="inner">
              <div class="formSelectPopup-box">
                <div class="formSelectPopup-zone">
                  <div class="formSelectPopup-header">
                    <input type="text" placeholder="핀 사이즈를 선택하세요." />
                  </div>
                  <ul class="formSelectPopup-body">
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>13</span>
                      </label>
                    </li>
                    <li>
                      <label>
                        <input type="radio" />
                        <input type="checkbox" />
                        <i></i>
                        <span>27</span>
                      </label>
                    </li>
                  </ul>
                  <div class="formSelectPopup-footer">
                    <button class="formSelectPopup-cancel">
                      취소
                    </button>
                    <!-- 비활성(Attribute) : disabled -->
                    <button class="formSelectPopup-confirm">
                      확인
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Layout */
import LeftLayout from '../layout/Left.vue'
import HeaderLayout from '../layout/Header.vue'
import FooterLayout from '../layout/Footer.vue'
import {settingService, userService} from '../../router'

export default {
  name: 'SE001',
  data () {
    return {
      clubInfo: {
        club_name: '',
        club_logo: '',
        club_address: '',
        club_telno: '',
        club_represent_name: '',
        active_status: 'inactive',
        manage_status: 'inactive',
        apl_status: 'ready',
        pin_size: '',
        pin_change: '',
        uniqueness: '',
        holiday_start: '',
        holiday_end: '',
        holiday_week_ju: '',
        holiday_week: '',
        region: ''
      },
      manageStatusName: '운영예정',
      selectManageStatus: 'inactive',
      manageStatusList: [
        {name: '운영중', code: 'active'},
        {name: '운영예정', code: 'inactive'}
      ],
      aplStatusName: '준비중',
      selectAplStatus: 'ready',
      aplStatusList: [
        {name: '서비스중', code: 'service'},
        {name: '점검중', code: 'check'},
        {name: '준비중', code: 'ready'}
      ],
      pinSize: '',
      selectPinSize: '',
      pinSizeArr: [
        {size: '13', code: '0'},
        {size: '20', code: '1'},
        {size: '27', code: '2'}
      ]
    }
  },
  created: function () {
    userService.getAll().then(response => {
      this.userInfo = response.data
    })
  },
  mounted: function () {
  },
  components: {
    LeftLayout,
    HeaderLayout,
    FooterLayout
  },
  methods: {
    confirmManageStatus: function () {
      this.clubInfo.manage_status = this.selectManageStatus
      this.manageStatusName = this.manageStatusList.find(it => it.code === this.clubInfo.manage_status).name
      this.closeSelectAll()
    },
    confirmAplStatus: function () {
      this.clubInfo.apl_status = this.selectAplStatus
      this.aplStatusName = this.aplStatusList.find(it => it.code === this.clubInfo.apl_status).name
      this.closeSelectAll()
    },
    confirmPinSize: function () {
      this.clubInfo.pin_size = this.selectPinSize
      this.pinSize = this.pinSizeArr.find(it => it.code === this.clubInfo.pin_size).size
      this.closeSelectAll()
    },
    saveData: function () {
      if (this.clubInfo.club_name === '') {
        this.openAlert('골프클럽명을 입력해주세요', null)
        return false
      } else {
        settingService.insertClubInfo(this.clubInfo).then(response => {
          if (response.statusCode === 200) {
            this.openAlert('저장되었습니다.', this.moveMenu('/SE001'))
          } else {
            this.openAlert(response.message, null)
          }
        }).catch(error => {
          console.log('getClubInfoList.err.===>', error)
        })
      }
    },
    handleImage: function (e) {
      const fileObj = e.target.files[0]
      this.createBase64Image(fileObj).then(data => {
        this.clubInfo.club_logo = data
      })
    },
    createBase64Image: function (fileObj) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(fileObj)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/setting/SE003.vue